import React from 'react';
import Tasks from './Tasks';

// Stranica identična admin "Zadaci" stranici, ali koristi nurse endpoint
// GET /api/Task/nurse-tasks-by-date
const NurseTasksPage = () => (
  <Tasks
    endpoint="/api/Task/nurse-tasks-by-date"
    showAddTask={false}
    selectable={false}
    collapseCategoriesByDefault={false}
  />
);

export default NurseTasksPage;
